import { Backdrop, Button, Card, CardContent, CircularProgress, Container, Divider, Grid, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, TablePagination, Typography, Checkbox, Paper, Box, InputAdornment, IconButton, Stack, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from 'src/components/Alert';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from 'date-fns/locale/tr';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import SendIcon from '@mui/icons-material/Send';
import PrintIcon from '@mui/icons-material/Print';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import * as XLSX from 'xlsx';

const localeMap = {
    tr: trLocale
};

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    table: {
        minWidth: 650,
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    title: (theme) => ({
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    }),
    media: (theme) => ({
        height: 210,
        padding: theme.spacing(6, 2)
    }),
    customCardContent: {
        '&.MuiCardContent-root:last-child': {
            paddingBottom: '0.65rem'
        }
    }
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;





function TeknisyenKocuGorusme() {
    const params = useParams();
    const SessionUser = getUser();
    const [search, setSearch] = React.useState('');
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [dataMain, setDataMain] = useState([]);
    const [mainSearchData, setMainSearchData] = useState([]);
    const [dataDetail, setDataDetail] = useState([]);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [DailerOpen, setDailerOpen] = React.useState(false);
    const [DailerData, setDailerData] = React.useState([]);
    const [DailerDataLink, setDailerDataLink] = React.useState('');
    const [audio, setAudio] = React.useState(new Audio(''));
    const [DailerOpenLink, setDailerOpenLink] = React.useState(false);
    const [UyariAciklama, setUyariAciklama] = useState("");
    const [expandedRowId, setExpandedRowId] = useState(null);

    const [projectData, setProjectData] = useState([]);
    const [selectedProject, setSelectedProject] = useState({ "ID": 0, "ACIKLAMA": "Tümü" });
    const [projectTypeLoading, setProjectTypeLoading] = useState(false);
    const [mainGroups, setMainGroups] = useState([]);
    const [selectedMainGroups, setSelectedMainGroups] = useState([]);
    const [bolgeAdiKodu, setBolgeAdiKodu] = useState([]);
    const [selectedBolgeAdiKodu, setSelectedBolgeAdiKodu] = useState([]);

    const [feedbackData, setFeedbackData] = useState({
        msgId: null,
        type: null,
        comment: ''
    });

    const waveformRef = useRef();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [StartDate, setStartDate] = useState(
        new Date()
    );
    const [EndDate, setEndDate] = useState(
        new Date()
    );
    const formattedStartDate = moment(StartDate).format('YYYY-MM-DD')
    const formattedEndDate = moment(EndDate).format('YYYY-MM-DD')
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    useEffect(() => {
        getMainGroups();
        getBolgeAdiKoduData();
        getMainData();
    }, []);

    const getMainGroups = () => {
        axios.get('/GetMainProductGroup')
            .then((response) => {
                setMainGroups(Array.isArray(response.data) ? response.data : []);
            })
            .catch(() => {
                setMainGroups([]);
            });
    };

    const getBolgeAdiKoduData = () => {
        axios.get(`GetBolgeAdiKodu/${SessionUser?.TopServiceShopCode}`)
            .then((response) => {
                setBolgeAdiKodu(Array.isArray(response?.data) ? response.data : []);
            })
            .catch(() => {
                setBolgeAdiKodu([]);
            });
    };

    const selectedMainGroupCodes = selectedMainGroups?.length > 0
        ? selectedMainGroups.map(item => item.ANA_GRUP_KODU).join(',')
        : '0';
    const selectedBolgeCodes = selectedBolgeAdiKodu?.length > 0
        ? selectedBolgeAdiKodu.map(item => item.BirimKodu).join(',')
        : '0';



    const getMainData = () => {
        setDataMain([]);
        setMainSearchData([]);
        setPage(0);
        setRowsPerPage(20);
        setSearch('');
        setDataDetail([]);
        setSelectedRowId(null);
        setExpandedRowId(null);
        setLoading(true);

        var selectedProjectId = selectedProject.ID
        axios.get(
            'GetTeknisyenKocuGorusme/'
            + formattedStartDate
            + '/'
            + formattedEndDate
            + '/'
            + encodeURIComponent(selectedBolgeCodes)
            + '/'
            + encodeURIComponent(selectedMainGroupCodes)
        )
            .then((response) => {
                const rows = Array.isArray(response.data) ? response.data : [];
                setDataMain(rows);
                setMainSearchData(rows);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }

    const getDetailData = (Id, userModelCode, UserId, beginDate, endDate) => {
        setDataDetail([]);
        setLoading(true);

        if (Id === null || Id === undefined) {
            Id = -1;
        }
        const dateBegin = beginDate ? beginDate : '1900-01-01';
        const dateEnd = endDate ? endDate : '2100-01-01';
        axios.get('GetTeknisyenKocuGorusmeDetay/' + Id + '/' + userModelCode + '/' + UserId + '/' + dateBegin + '/' + dateEnd)
            .then((response) => {
                setDataDetail(Array.isArray(response.data) ? response.data : []);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }


    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };



    const handleSearch = async (event) => {


        const newString = event?.target.value;
        setSearch(newString);
        if (newString) {
            const lowercasedNewString = newString.toLowerCase('tr-TR');
            const filteredData = mainSearchData.filter(item => {
                const concatenatedStr = `${item.receiptNumber}
                ${item.UserId}
                ${item.TEKNISYEN}
                ${item.UST_BIRIM_KODU}
                ${item.KUL_BIRIM_KODU}
                ${item.SERVIS}
                ${item.ANA_GRUP}
                ${item.userModelCode}
                ${item.MODEL}
                ${item.BANKANO}`;
                const lowercasedConcatenatedStr = concatenatedStr.toLowerCase('tr-TR');
                return lowercasedConcatenatedStr.includes(lowercasedNewString);
            });
            setDataMain(filteredData);
        } else {
            setDataMain(mainSearchData);
        }
    };

    const toggleExpanded = (id) => {
        setExpandedRowId(prev => prev === id ? null : id);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    function convertMarkdown(md) {
        if (!md) return "";
        let html = md;
        // #### başlık
        html = html.replace(/^\s*#### (.*)$/gm, "<h4>$1</h4>");
        // ### başlık
        html = html.replace(/^\s*### (.*)$/gm, "<h3>$1</h3>");
        // ## başlık
        html = html.replace(/^\s*## (.*)$/gm, "<h2>$1</h2>");
        // # başlık
        html = html.replace(/^\s*# (.*)$/gm, "<h1>$1</h1>");
        // Bold
        html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
        // PARAGRAF (çift newline)
        html = html.replace(/\n\s*\n/g, "</p><p>");
        // TEK NEWLINE → <br/>
        html = html.replace(/\n/g, "<br/>");
        // Paragraf etiketlerine sar
        html = "<p>" + html + "</p>";
        return html;
    }

    const handleFeedbackClick = (id, type) => {
        // Eğer aynı butona tekrar basarsa alanı kapat (toggle)
        if (feedbackData.msgId === id && feedbackData.type === type) {
            setFeedbackData({ msgId: null, type: null, comment: '' });
        } else {
            setFeedbackData({ msgId: id, type: type, comment: '' });
        }
    };

    const handleDownloadExcel = () => {
        setLoading(true);
        axios.get(`GetTeknisyenKocuGorusmeExcel/${formattedStartDate}/${formattedEndDate}/${encodeURIComponent(selectedBolgeCodes)}/${encodeURIComponent(selectedMainGroupCodes)}`)
            .then((response) => {
                if (response.data && response.data.length > 0) {

                    // SQL'de her ID için 2 satır geliyor:
                    // Role='Teknisyen'    → Soru (KAYIT_TARIHI orijinal)
                    // Role='SanalAsistan' → Cevap (KAYIT_TARIHI = orijinal + 10sn)
                    // Bu yüzden ID'ye göre grupluyoruz, ardından Role'e göre ayırıyoruz.
                    const groupedById = response.data.reduce((acc, item) => {
                        const key = item.ID;
                        if (!acc[key]) acc[key] = [];
                        acc[key].push(item);
                        return acc;
                    }, {});

                    // Grupları sorgunun KAYIT_TARIHI'ne göre DESC sırala,
                    // flatten SONRA yaparak soru-cevap çiftlerinin birbirinden ayrılmasını önle.
                    const sortedGroups = Object.values(groupedById).sort((a, b) => {
                        const aSoru = a.find(r => r.Role === 'Teknisyen') || a[0];
                        const bSoru = b.find(r => r.Role === 'Teknisyen') || b[0];
                        return new Date(bSoru.KAYIT_TARIHI) - new Date(aSoru.KAYIT_TARIHI);
                    });

                    const excelData = sortedGroups.flatMap(group => {
                        const soru = group.find(r => r.Role === 'Teknisyen');
                        const cevap = group.find(r => r.Role === 'SanalAsistan');
                        const base = soru || cevap;

                        const baseFields = {
                            FisNo: base.FisNo,
                            ÜrünGrup: base.URUN_GRUBU,
                            ModelKodu: base.MODEL_KODU,
                            Model: base.MODEL,
                            Teknisyen: base.Teknisyen,
                            BölgeKodu: base.UST_BIRIM_KODU,
                            Bölge: base.UST_BIRIM,
                            ServisKodu: base.KUL_BIRIM_KODU,
                            Servis: base.SERVIS,
                            BankaNo: base.BANKANO,
                        };

                        const rows = [];
                        if (soru) {
                            rows.push({
                                ...baseFields,
                                SoruCevap: 'Soru',
                                Tarih: soru.MESAJ_TARIHI,
                                Mesaj: soru.Content,
                                Rol: soru.Role,
                                HazırSoruMu: '',
                                AgentCevap: '',
                                Beğenildimi: '',
                                Yorum: '',
                                YorumYapanKisi: ''
                            });
                        }
                        if (cevap) {
                            rows.push({
                                ...baseFields,
                                SoruCevap: 'Cevap',
                                Tarih: cevap.MESAJ_TARIHI,
                                Mesaj: cevap.Content,
                                Rol: cevap.Role,
                                HazırSoruMu: cevap.IsQuickQuestion,
                                AgentCevap: cevap.IsAnsweredByAgent,
                                Beğenildimi: cevap.IsLiked,
                                Yorum: cevap.FeedbackComment,
                                YorumYapanKisi: cevap.YorumYapanKisi
                            });
                        }
                        return rows;
                    });

                    const worksheet = XLSX.utils.json_to_sheet(excelData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'GorusmeDetay');
                    XLSX.writeFile(workbook, `TeknisyenKocuGorusmeDetaylı_${formattedStartDate}_${formattedEndDate}.xlsx`);

                    setUyariTip('success');
                    setUyari(true);
                    setresponseMessage({
                        ErrorCode: '0',
                        ErrorDescription: 'Excel dosyası başarıyla indirildi.'
                    });

                } else {
                    setUyariTip('error');
                    setUyari(true);
                    setresponseMessage({
                        ErrorCode: '1000',
                        ErrorDescription: 'Excel dosyası indirilirken hata oluştu.1'
                    });
                }
                setLoading(false);
            })
            .catch((error) => {
                setUyariTip('error');
                setUyari(true);
                setresponseMessage({
                    ErrorCode: '1000',
                    ErrorDescription: 'Excel dosyası indirilirken hata oluştu.'
                });
                setLoading(false);
            });
    };

    const handleSendFeedback = async () => {
        setLoading(true);

        const questionMsg = dataDetail.find(msg => msg.ID === feedbackData.msgId);

        // questionMsg'ın index'ini ID'ye göre bul
        const questionIndex = dataDetail.findIndex(msg => msg.ID === feedbackData.msgId);

        // questionIndex'ten önceki mesajları al, tersine çevir ve SanalAsistan'ı bul
        const answerMsg = questionIndex > 0
            ? [...dataDetail]
                .slice(0, questionIndex)
                .reverse()
                .find(msg => msg.Role === 'SanalAsistan')
            : null;

        const data = {
            MsgId: feedbackData.msgId,
            Answer: answerMsg?.Content || '',
            Question: questionMsg?.Content || '',
            IsLiked: feedbackData.type === 'like' ? 1 : 0,
            FeedbackComment: feedbackData.comment,
            ApplicationId: 1,
        }

        axios.post('SetTeknisyenKocuFeedbackSend', data)
            .then((response) => {
                if (response.data && response.data.ErrorCode === '0') {
                    setUyariTip('success');
                    setUyari(true);
                    setresponseMessage({
                        ErrorCode: '0',
                        ErrorDescription: 'Geri bildiriminiz başarıyla kaydedildi.'
                    });
                    setFeedbackData({ msgId: null, type: null, comment: '' });
                } else {
                    setUyariTip('error');
                    setUyari(true);
                    setresponseMessage(response.data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setUyariTip('error');
                setUyari(true);
                setresponseMessage({
                    ErrorCode: '1',
                    ErrorDescription: 'Geri bildirim gönderilirken hata oluştu.'
                });
                setLoading(false);
            });
    };

    return (
        <Page sx={styles.root}>
            <Backdrop sx={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage.ErrorDescription}
                ></Alert>
            </Snackbar>
            <Container maxWidth={false}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedBolgeAdiKodu}
                                    options={bolgeAdiKodu}
                                    getOptionLabel={(option) => option?.Dsc || ""}
                                    isOptionEqualToValue={(option, value) => option?.BirimKodu === value?.BirimKodu}
                                    onChange={(event, newValue) => {
                                        setSelectedBolgeAdiKodu(newValue);
                                    }}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option?.Dsc}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={'B\u00f6lge'}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Autocomplete
                                    multiple
                                    size="small"
                                    fullWidth
                                    limitTags={1}
                                    disableCloseOnSelect
                                    value={selectedMainGroups}
                                    options={mainGroups}
                                    getOptionLabel={(option) => option?.ANA_GRUP || ""}
                                    isOptionEqualToValue={(option, value) => option?.ANA_GRUP_KODU === value?.ANA_GRUP_KODU}
                                    onChange={(event, newValue) => {
                                        setSelectedMainGroups(newValue);
                                    }}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option?.ANA_GRUP}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={'Ana \u00dcr\u00fcn Grubu'}
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={localeMap['tr']}
                                >
                                    <DatePicker
                                        label={'Başlangıç Tarihi'}
                                        format={'dd.MM.yyyy'}
                                        value={StartDate}
                                        onChange={date => {
                                            setStartDate(date);
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                    adapterLocale={localeMap['tr']}
                                >
                                    <DatePicker
                                        label={'Bitiş Tarihi'}
                                        format={'dd.MM.yyyy'}
                                        value={EndDate}
                                        onChange={date => {
                                            setEndDate(date);
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                color: 'primary',
                                                variant: 'outlined'
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    placeholder="Arama"
                                    value={search}
                                    onChange={handleSearch}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 2,
                                    lg: 2
                                }}>
                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                    <Button
                                        className={styles.action}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => {
                                            getMainData();
                                        }}
                                    >
                                        Sorgula
                                        <SearchIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleDownloadExcel}
                                        disabled={!dataMain || dataMain.length === 0}
                                    >
                                        Excel İndir
                                        <PrintIcon style={{ marginLeft: '5px' }} />
                                    </Button>
                                </Stack>
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                    lg: 12
                                }}>
                                <Divider />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 8,
                                    lg: 9
                                }}>
                                <TableContainer style={{ maxHeight: 700, minHeight: 700, overflowY: 'auto' }}>
                                    <Table stickyHeader aria-label="sticky table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>FisNo</TableCell>
                                                <TableCell>Tarih</TableCell>
                                                <TableCell>Kullanıcı</TableCell>
                                                <TableCell>Teknisyen</TableCell>
                                                <TableCell>Bölge</TableCell>
                                                <TableCell>ServisKodu</TableCell>
                                                <TableCell>Servis</TableCell>
                                                <TableCell>ÜrünGrup</TableCell>
                                                <TableCell>ModelKodu</TableCell>
                                                <TableCell>Model</TableCell>
                                                <TableCell>BankaNo</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(dataMain || []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                                <TableRow
                                                    key={`${row.receiptNumber}-${index}`}
                                                    onClick={() => {
                                                        setSelectedRowId(`${row.receiptNumber}-${index}`);
                                                        getDetailData(row.receiptNumber, row.userModelCode, row.UserId, row.BeginDate, row.EndDate);
                                                    }}
                                                    style={{
                                                        backgroundColor: `${row.receiptNumber}-${index}` === selectedRowId ? '#e0f7fa' : 'transparent',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.receiptNumber}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.KAYIT_TARIHI}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.UserId}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.TEKNISYEN}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.UST_BIRIM_KODU}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.KUL_BIRIM_KODU}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.SERVIS}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.ANA_GRUP}</Typography></TableCell>
                                                    <TableCell><Typography variant="body2" sx={{ mt: 0.5 }}>{row.userModelCode}</Typography></TableCell>
                                                    <TableCell style={{ maxWidth: 150 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.receiptNumber} sx={{ flex: 1 }}>
                                                                {row.MODEL}
                                                            </Typography>
                                                            <Tooltip title={expandedRowId === row.receiptNumber ? 'Daralt' : 'Tam metni göster'}>
                                                                <IconButton
                                                                    size="small"
                                                                    sx={{ p: 0.25 }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleExpanded(row.receiptNumber);
                                                                    }}
                                                                >
                                                                    <UnfoldMoreIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell style={{ maxWidth: 90 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                            <Typography variant="body2" noWrap={!expandedRowId || expandedRowId !== row.receiptNumber} sx={{ flex: 1 }}>
                                                                {row.BANKANO}
                                                            </Typography>
                                                            <Tooltip title="Panoya kopyala">
                                                                <IconButton
                                                                    size="small"
                                                                    sx={{ p: 0.25 }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        navigator.clipboard.writeText(row.BANKANO || '')
                                                                            .then(() => {
                                                                                setUyariTip('success');
                                                                                setUyari(true);
                                                                                setresponseMessage({ ErrorCode: '0', ErrorDescription: 'Panoya kopyalandı.' });
                                                                            })
                                                                            .catch(() => {
                                                                                setUyariTip('error');
                                                                                setUyari(true);
                                                                                setresponseMessage({ ErrorCode: '1', ErrorDescription: 'Kopyalama başarısız oldu.' });
                                                                            });
                                                                    }}
                                                                >
                                                                    <ContentCopyIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {(!dataMain || dataMain.length === 0) && (
                                                <TableRow>
                                                    <TableCell colSpan={11} align="center" sx={{ py: 6, color: 'text.secondary' }}>
                                                        Kayıt bulunamadı
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 20, 40, 80, 100]}
                                    component="div"
                                    count={(dataMain || []).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Grid>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 4,
                                    lg: 3
                                }}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        height: 700,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #e0e0e0'
                                    }}
                                >
                                    {/* Header */}
                                    <Box
                                        sx={{
                                            p: 2,
                                            backgroundColor: '#f5f5f5',
                                            color: '#000',
                                        }}
                                    >
                                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
                                            Görüşme Detayı
                                        </Typography>
                                    </Box>

                                    {/* Messages Area */}
                                    <Box
                                        sx={{
                                            flex: 1,
                                            overflowY: 'auto',
                                            p: 2,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1.5,
                                            backgroundColor: '#ffffff',
                                            '&::-webkit-scrollbar': {
                                                width: '6px'
                                            },
                                            '&::-webkit-scrollbar-track': {
                                                backgroundColor: '#f5f5f5'
                                            },
                                            '&::-webkit-scrollbar-thumb': {
                                                backgroundColor: '#bdbdbd',
                                                borderRadius: '3px',
                                                '&:hover': {
                                                    backgroundColor: '#9e9e9e'
                                                }
                                            }
                                        }}
                                    >
                                        {dataDetail && dataDetail.length > 0 ? (
                                            dataDetail.map((msg, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: msg.Role === 'SanalAsistan' ? 'flex-start' : 'flex-end'
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            maxWidth: '85%',
                                                            p: 1.5,
                                                            borderRadius: msg.Role === 'SanalAsistan' ? '12px 12px 12px 2px' : '12px 12px 2px 12px',
                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                                            backgroundColor: msg.Role === 'SanalAsistan' ? '#f5f5f5' : '#FFF3E0',
                                                        }}
                                                    >
                                                        {/* Message Content */}
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                mt: 1,
                                                                lineHeight: 1.6,
                                                                fontSize: '0.875rem',
                                                                color: '#212121',
                                                                wordBreak: 'break-word'
                                                            }}
                                                        >
                                                            {msg.ContentType === 'Text' ? (
                                                                msg.Content
                                                            ) : (
                                                                <span dangerouslySetInnerHTML={{ __html: convertMarkdown(msg.Content) }} />
                                                            )}
                                                        </Typography>

                                                        {/* Timestamp */}
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                display: 'block',
                                                                mt: 1,
                                                                fontSize: '0.65rem',
                                                                color: '#8a8a8a',
                                                                textAlign: msg.Role === 'SanalAsistan' ? 'left' : 'right'
                                                            }}
                                                        >
                                                            {msg.DATE}
                                                        </Typography>

                                                        {/* Feedback Area */}
                                                        {msg.Role === 'SanalAsistan' && (
                                                            <>
                                                                <Divider sx={{ my: 1, borderColor: '#e0e0e0' }} />
                                                                <Stack direction="column" spacing={1}>
                                                                    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleFeedbackClick(msg.ID, 'like')}
                                                                            sx={{
                                                                                padding: '4px',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'rgba(76, 175, 80, 0.1)'
                                                                                }
                                                                            }}
                                                                        >
                                                                            <ThumbUpOutlinedIcon
                                                                                sx={{
                                                                                    color: feedbackData.msgId === msg.ID && feedbackData.type === 'like' ? '#4caf50' : '#9e9e9e',
                                                                                    fontSize: '1rem'
                                                                                }}
                                                                            />
                                                                        </IconButton>

                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleFeedbackClick(msg.ID, 'dislike')}
                                                                            sx={{
                                                                                padding: '4px',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'rgba(244, 67, 54, 0.1)'
                                                                                }
                                                                            }}
                                                                        >
                                                                            <ThumbDownOutlinedIcon
                                                                                sx={{
                                                                                    color: feedbackData.msgId === msg.ID && feedbackData.type === 'dislike' ? '#f44336' : '#9e9e9e',
                                                                                    fontSize: '1rem'
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </Stack>

                                                                    {feedbackData.msgId === msg.ID && (
                                                                        <Box sx={{ mt: 1 }}>
                                                                            <TextField
                                                                                fullWidth
                                                                                size="small"
                                                                                variant="outlined"
                                                                                multiline
                                                                                minRows={2}
                                                                                placeholder="Geri bildiriminizi yazınız..."
                                                                                value={feedbackData.comment}
                                                                                onChange={(e) => setFeedbackData({ ...feedbackData, comment: e.target.value })}
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        backgroundColor: '#fff',
                                                                                        fontSize: '0.85rem',
                                                                                        '& fieldset': {
                                                                                            borderColor: '#e0e0e0'
                                                                                        },
                                                                                        '&:hover fieldset': {
                                                                                            borderColor: '#bdbdbd'
                                                                                        },
                                                                                        '&.Mui-focused fieldset': {
                                                                                            borderColor: '#FF9800'
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            <IconButton
                                                                                                onClick={handleSendFeedback}
                                                                                                disabled={!feedbackData.comment.trim()}
                                                                                                size="small"
                                                                                                sx={{
                                                                                                    color: '#FF9800',
                                                                                                    '&:disabled': {
                                                                                                        color: '#bdbdbd'
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <SendIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        </InputAdornment>
                                                                                    )
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    )}
                                                                </Stack>
                                                            </>
                                                        )}
                                                    </Box>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '100%',
                                                    color: '#bdbdbd'
                                                }}
                                            >
                                                <ChatBubbleOutlineIcon sx={{ fontSize: 48, mb: 2, opacity: 0.3 }} />
                                                <Typography variant="body2" sx={{ color: '#757575', textAlign: 'center' }}>
                                                    Görüşme detayı görmek için bir kayıt seçin
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </Page >
    );
}
export default TeknisyenKocuGorusme;
